var exports = {
  "iE": "xae11d333--fbb7cf--wrapper",
  "kL": "xae11d333--fbb7cf--container",
  "AS": "xae11d333--fbb7cf--item",
  "UE": "xae11d333--fbb7cf--arrow",
  "qY": "xae11d333--fbb7cf--left-arrow",
  "JO": "xae11d333--fbb7cf--right-arrow",
  "Ff": "xae11d333--fbb7cf--items-per-screen-fixed",
};

module.exports = exports;
